import { useMemo } from 'react';
import { Flex } from 'antd';
import { getProgressFromSections } from 'pages/EvidencePage/helpers';
import type { EvidenceProgress, EvidenceSection } from 'api/brokerCases/types';
import type { IDocumentFormatted } from 'queries/applications/useApplicationByReferenceNumber/types';
import { CustomerFilesList, NextSteps } from './components/index';

export interface IOverviewPageProps {
  sections: EvidenceSection[];
  applicationFilesInternal?: IDocumentFormatted[];
  onGoToEvidenceV2?: () => void;
}

export const OverviewPage = ({ sections, applicationFilesInternal, onGoToEvidenceV2 }: IOverviewPageProps) => {
  const progress: EvidenceProgress = useMemo(() => getProgressFromSections(sections), [sections]);

  return (
    <Flex className='w-full gap-8'>
      <CustomerFilesList documents={applicationFilesInternal} />
      <NextSteps progress={progress} onGoToEvidenceV2={onGoToEvidenceV2} />
    </Flex>
  );
};
